import React, { useState } from "react";
import BusinessHoursTable from "./businessHoursTable";
import { Accordion } from "react-bootstrap";
import AccordionCustomToggle from "../accordionCustomToggle/accordionCustomToggle";

const BusinessHoursAccordion = ({ title, daysArray, titleClass }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const accordionTab = document.getElementById("accordionTab");

  accordionTab &&
    accordionTab.addEventListener("keydown", (event) => {
      if (event.key === " " || event.key === "Space") {
        event.preventDefault();
      }
    });

  return (
    <Accordion defaultActiveKey="1">
      <div
        id="accordionTab"
        onClick={handleAccordion}
        onKeyUp={(e) => {
          if (e.key === " " || e.key === "Enter") {
            e.preventDefault();
            e.stopPropagation();
            handleAccordion();
          }
        }}
      >
        <AccordionCustomToggle eventKey="0" isOpen={isOpen}>
          <span
            className={`${titleClass} businessHours__toggleContainer`}
            style={{ cursor: "pointer" }}
            tabIndex={0}
          >
            {title}
          </span>
        </AccordionCustomToggle>
      </div>
      <Accordion.Collapse eventKey="0" in={isOpen}>
        <BusinessHoursTable daysArray={daysArray} />
      </Accordion.Collapse>
    </Accordion>
  );
};

export default BusinessHoursAccordion;
